export default "__VITE_ASSET__Drd8F$Vc__"